// extracted by mini-css-extract-plugin
module.exports = {"main":"Research_main__1kCqB"};